// ============================================
// MOBILE NAVIGATION MODULE
// ============================================

(function () {
  'use strict';

  var navToggle = document.querySelector('.navbar__toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileNavClose = mobileNav ? mobileNav.querySelector('.mobile-nav__close') : null;

  if (!navToggle || !mobileNav) return;

  var isOpen = false;
  var isAnimating = false;

  // Collect all animatable elements and assign stagger indices
  function assignStaggerIndices() {
    var logo = mobileNav.querySelector('.mobile-nav__logo');
    var closeBtn = mobileNav.querySelector('.mobile-nav__close');
    var items = mobileNav.querySelectorAll('.mobile-nav__item');

    var idx = 0;

    // Logo first
    if (logo) {
      logo.style.setProperty('--i', idx++);
    }

    // Menu items bottom to top (Historia Winston → Win Club)
    for (var i = items.length - 1; i >= 0; i--) {
      items[i].style.setProperty('--i', idx++);
    }

    // Close button last
    if (closeBtn) {
      closeBtn.style.setProperty('--i', idx++);
    }
  }

  function openNav() {
    if (isAnimating) return;
    isOpen = true;
    isAnimating = true;

    assignStaggerIndices();

    mobileNav.classList.remove('is-closing');
    navToggle.classList.add('is-active');
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    navToggle.setAttribute('aria-label', 'Zamknij menu');
    document.body.classList.add('nav-open');

    // Allow animations to finish
    setTimeout(function () {
      isAnimating = false;
    }, 600);
  }

  function closeNav() {
    if (isAnimating || !isOpen) return;
    isOpen = false;
    isAnimating = true;

    mobileNav.classList.add('is-closing');

    setTimeout(function () {
      mobileNav.classList.remove('is-open');
      mobileNav.classList.remove('is-closing');
      navToggle.classList.remove('is-active');
      mobileNav.setAttribute('aria-hidden', 'true');
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', 'Otwórz menu');
      document.body.classList.remove('nav-open');
      isAnimating = false;
    }, 300);
  }

  function toggleNav() {
    if (isOpen) {
      closeNav();
    } else {
      openNav();
    }
  }

  // Toggle on button click
  navToggle.addEventListener('click', toggleNav);

  // Close on overlay close button click
  if (mobileNavClose) {
    mobileNavClose.addEventListener('click', closeNav);
  }

  // Close nav when clicking on a link
  mobileNav.querySelectorAll('.mobile-nav__link').forEach(function (link) {
    link.addEventListener('click', function () {
      // Only close if it's not a dropdown toggle
      if (!link.closest('.mobile-nav__item--has-dropdown') || !link.querySelector('.icon-plus')) {
        closeNav();
      }
    });
  });

  // Close nav when clicking on dropdown card links
  mobileNav.querySelectorAll('.mobile-dropdown__card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Don't close nav if clicking a popover trigger inside the card
      if (e.target.closest('[data-popover-trigger]')) return;
      closeNav();
    });
  });

  // Close nav on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      closeNav();
      navToggle.focus();
    }
  });

  // Close nav on window resize to desktop
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 925 && isOpen) {
      // Instant close on resize (no animation)
      mobileNav.classList.remove('is-open');
      mobileNav.classList.remove('is-closing');
      navToggle.classList.remove('is-active');
      mobileNav.setAttribute('aria-hidden', 'true');
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', 'Otwórz menu');
      document.body.classList.remove('nav-open');
      isOpen = false;
      isAnimating = false;
    }
  });
})();
